import { TimeSpanConfig } from '@bryntum/schedulerpro';
import { humanise } from 'components/atoms/humanised-date';
import { useTranslate } from 'hooks/use-translation';
import { AvailabilityFilter } from '../types';
import { maximumDate, minimumDate } from './common';

export const idForAvailablityRange = 'range-for-availablility-span';
export const idForRangeBeforeAvailability = 'range-before-availablility';
export const idForRangeAfterAvailability = 'range-after-availablility';
export const idsForTimeRanges = [
  idForAvailablityRange,
  idForRangeBeforeAvailability,
  idForRangeAfterAvailability,
];

export const getTimeRangesForAvailabilityFilter = (
  availabilityFilter: AvailabilityFilter,
  hideUnavailableAreas: boolean,
  translate: ReturnType<typeof useTranslate>,
): Partial<TimeSpanConfig>[] => {
  const spanForAvailablilityRange = {
    id: idForAvailablityRange,
    cls: 'available-range',
    name: translate('resource_management.availability_criteria.range_header', {
      startDate: humanise(availabilityFilter.startDate),
      endDate: humanise(availabilityFilter.endDate),
    }),
    startDate: availabilityFilter.startDate.startOf('day').toDate(),
    endDate: availabilityFilter.endDate.endOf('day').toDate(),
  };
  const spanBeforeAvailabilityRange = {
    id: idForRangeBeforeAvailability,
    cls: 'unavailable-range',
    startDate: minimumDate.toDate(),
    endDate: availabilityFilter.startDate
      .subtract(1, 'day')
      .endOf('day')
      .toDate(),
  };
  const spanAfterAvailabilityRange = {
    id: idForRangeAfterAvailability,
    cls: 'unavailable-range',
    startDate: availabilityFilter.endDate.add(1, 'day').startOf('day').toDate(),
    endDate: maximumDate.toDate(),
  };

  return hideUnavailableAreas
    ? [
        spanForAvailablilityRange,
        spanBeforeAvailabilityRange,
        spanAfterAvailabilityRange,
      ]
    : [spanForAvailablilityRange];
};
